import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import viTranslations from '../lang/vi.json';
import enTranslations from '../lang/en.json';

const setupI18n = async (defaultLanguage = 'vi') => {
  await i18next.use(initReactI18next).init({
    lng: defaultLanguage,
    fallbackLng: false,
    resources: {
      vi: {
        translation: viTranslations,
      },
      en: {
        translation: enTranslations,
      },
    },
    interpolation: {
      escapeValue: false,
    },
  });
};


const setLanguage = async (language) => {
  if (!language) {
    language = 'en' // Mặc định là tiếng Anh
  }
  await i18next.changeLanguage(language);
  // Không tự động lưu vào localStorage ở đây
  // Chỉ lưu khi user đã đăng nhập và chủ động đổi ngôn ngữ trong NavLanguage
};

setupI18n();

export { i18next as I18n, setLanguage };
